import { Component, Input } from '@angular/core';

@Component({
  selector: 'chat-bubble-user',
  templateUrl: 'chat-bubble-user.component.html',
  styleUrl: './chat-bubble-user.component.scss'
})
export class ChatBubbleUserComponent {
  @Input() message!: string;  
}
